enum DetailsType {
    PropertyDetails = "PropertyDetails",
    DealDetails = "DealDetails",
    DealEdit = "DealEdit",
    DealCreate = "DealCreate",
    DealCreateFromProperty = "DealCreateFromProperty",
    DealCreateFromLead = "DealCreateFromLead",
    LeadDetails = "LeadDetails",
    LeadEdit = "LeadEdit",
    LeaseCompDetails = "LeaseCompDetails",
    LeaseCompEdit = "LeaseCompEdit",
    LeaseCompCreate = "LeaseCompCreate",
    SaleCompDetails = "SaleCompDetails",
    SaleCompEdit = "SaleCompEdit",
    SaleCompCreate = "SaleCompCreate",
    CompanyDetails = "CompanyDetails",
    CompanyEdit = "CompanyEdit",
    TenantInMarketDetails = "TenantInMarketDetails",
    TenantInMarketEdit = "TenantInMarketEdit",
    TenantInMarketCreate = "TenantInMarketCreate",
    Insights = "Insights",
}

export default DetailsType;